var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import clsx from "clsx";
import { createUseStyles, useTheme } from "react-jss";
import Color from "color";
//Styles pulled from MaterialUI for now.
var useStyles = createUseStyles(function (theme) { return ({
    button: {
        display: "inline-flex",
        color: "#fff",
        backgroundColor: function (props) { return props.baseBGColor; },
        padding: "6px 16px",
        fontSize: "0.875rem",
        minWidth: 64,
        boxSizing: "border-box",
        transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        fontFamily: '"Anova","Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 700,
        lineHeight: "1.75",
        borderRadius: 8,
        letterSpacing: "0.02857em",
        textTransform: theme.welcome.actionButton.textTransform,
        border: 0,
        outline: 0,
        position: "relative",
        alignItems: "center",
        userSelect: "none",
        verticalAlign: "middle",
        justifyContent: "center",
        textDecoration: "none",
        cursor: "pointer",
        "-webkit-appearance": "none",
        "-webkit-tap-highlight-color": "transparent",
        "&:enabled, &:not(.disabled)": {
            boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
            cursor: "pointer",
        },
        "&:hover:enabled, &:not(.disabled):hover": {
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
            backgroundColor: function (props) { return props.hoverBGColor; }
        },
        "&:active:enabled, &:not(.disabled):active": {
            backgroundColor: function (props) { return props.activeBGColor; },
        },
        "&:disabled, &.disabled": {
            backgroundColor: function (props) { return props.disabledBGColor; },
            color: "rgba(0,0,0,0.4)",
            cursor: "default"
        }
    },
}); });
var Button = function (props) {
    var theme = useTheme();
    var className = props.className, backgroundColor = props.backgroundColor, _a = props.component, component = _a === void 0 ? "button" : _a, other = __rest(props, ["className", "backgroundColor", "component"]);
    var Component = component;
    var baseBGColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "primary";
    if (theme.color.hasOwnProperty(baseBGColor)) {
        // @ts-ignore
        baseBGColor = theme.color[baseBGColor].main;
    }
    var baseBGColorObject = Color(baseBGColor);
    var classes = useStyles({
        baseBGColor: baseBGColor,
        hoverBGColor: props.lighten ? baseBGColorObject.lighten(0.1).toString() : baseBGColorObject.darken(0.5).toString(),
        activeBGColor: props.lighten ? baseBGColorObject.lighten(0.1).mix(Color("white"), 0.3).toString() : baseBGColorObject.darken(0.5).mix(Color("white"), 0.3).toString(),
        disabledBGColor: props.lighten ? baseBGColorObject.darken(0.5).toString() : "rgba(255,255,255,.4)",
    });
    var buttonClass = clsx(classes.button, props.className, props.disabled && "disabled");
    return (React.createElement(Component, __assign({ className: buttonClass, disabled: false, "data-qa": "button" }, other), props.children));
};
export default Button;
//# sourceMappingURL=Button.js.map